import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import styles from '../../styles/DynamicModal.module.css';

import IconContainer from '../IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

const ModalContext = React.createContext();

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [modalHeader, setHeaderContent] = React.useState('Ошибка');
  const [modalContent, setModalContent] = React.useState('Данное содержимое недоступно');

  const openModal = (header, content) => {
    setHeaderContent(header);
    setModalContent(() => content);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  React.useEffect(() => {
    const body = document.querySelector('body');
    if (isModalOpen) {
      body.classList.add('modal-open');
    } else {
      body.classList.remove('modal-open');
    }
  }, [isModalOpen]);

  // Анимация для модального окна
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
  };

  return (
    <ModalContext.Provider value={{ isModalOpen, openModal, closeModal, modalHeader, modalContent }}>
      {children}

      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            className={styles.liningOver}
            onClick={closeModal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className={styles.lining}
              onClick={(e) => e.stopPropagation()}
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ duration: 0.2 }}
            >
                <div className={styles.header}>
                    <h1>{modalHeader}</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                  {modalContent && typeof modalContent === 'function' ? modalContent() : modalContent}
                  <div className='panelFormConfirmation'>
                    <a></a>
                    <button className="button" onClick={closeModal}>Понятно</button>
                  </div>
                </div>
            </motion.div>
        </motion.div>
        )}
      </AnimatePresence>
    </ModalContext.Provider>
  );
};

export const useModal = () => React.useContext(ModalContext);
